<template>
  <v-icon
    v-tooltip="$t(`contracts.status.${status}`)"
    :color="getContractStatusColor(status)"
    variant="tonal"
    density="compact"
    label
    :icon="getContractStatusIcon(status)"
    size="small"
  />
</template>

<script setup lang="ts">
const { status } = defineProps<{ status: ContractStatus }>()
</script>
